
export const BusHomeGAEvents = {
  category:"bus_Home",
  actions:{
    bus_search:"bus_search",
    bus_search_swap:"bus_search_swap",
    bus_recent_search:"bus_recent_search"
  },
}
export const SrpGAEvents = {
  category:"bus_SRP",
  actions:{
    bus_srp_filter:{
      val:"bus_srp_filter",
      labels:{
        popular:"popular",
        busType:"busType",
        operator:"operator",
        boardingPoint:"boardingPoint",
        droppingPoint:"droppingPoint",
        amenities:"amenities",
        arrivalTime:"arrivalTime",
        departureTime:"departureTime"
      },
      addLabelCustomValue:true,
      labelCustomeValueSeperator:"-"
    },
    bus_srp_sort:{
      val:"bus_srp_sort",
      labels:{
        best:"best",
        low_price:"low_price",
        high_price:"high_price",
        low_speed:"low_speed",
        high_speed:"high_speed",
        early_arrival:"early_arrival",
        late_arrival:"late_arrival",
        early_departure:"early_departure",
        late_departure:"late_departure",
        rating_low:"rating_low",
        rating_high:"rating_high"
            
      }
    },
    bus_updatesearch:"bus_updatesearch",
    bus_previousday:"bus_previousday",
    bus_nextday:"bus_nextday",
    bus_boardingdropping:"bus_boardingdropping",
    bus_moredetails:"bus_moredetails",
    bus_proceedtoSeat:{
      val:"bus_proceedtoSeat",
      labels:{
        show:"show",
        hide:"hide"
      }
    },
    bus_hide_details:"bus_hide_details",
    bus_SRP_load:{
      val:"bus_SRP_load",
      labels:{
        success:"success",
        deadend:"deadend",
        failure:"failure"
      }
    }
  },
}
export const AlternateRouteGAEvents = {
  category:"bus_alternate_route",
  actions:{
    updatesearch:"updatesearch",
    nextdate:"nextdate",
    alternateroute:"alternateroute"
    
  }
}

export const SeatLayoutEvents={
  category:"bus_Seatlayout",
  actions:{
    bus_seatlayout_tab:{
      val:"bus_seatlayout_tab",
      labels:{
        seatLayout:"seatLayout",
        policies:"policies",
        amenities_photos:"amenities_photos",
        boarding_dropping:"boarding_dropping",
        reviews:"reviews"    
      }
    },
    selectseat:"selectseat",
    proceedToReview:"proceedToReview",
    priceChange:"priceChange",
    lastMinutebBooking: {
      val: "lastMinutebBooking",
      label: "lmbBusClicked"
    }
  }
}


export const ReviewEvents={
  category:"bus_Review",
  actions:{
    view_all_promo:"view_all_promo",
    view_cancellation_policy:"view_cancellation_policy",
    insurance_tc:"insurance_tc",
    price_detail:"price_detail",
    pay:"pay",
    validationError:"validationError",
    tentativeComplete:"tentativeComplete"
  }
}
 export const pageView={
  SRP_NEW:"SRP_NEW",
  HOME_NEW:"HOME_NEW",
  REVIEW_NEW:"REVIEW_NEW"
 }

 export const ThankyouPageEvents={
  category: 'Bus',
  pages: {
    tynpsrating: 'tynpsrating',
    tynps_45input: 'tynps_45input',
    tynps_givefeedback: 'tynps_givefeedback'
  },
  eventCategory: {
    openScreen: 'openscreen',
    closeScreen: 'event_close',
    rating: 'event_ratinggiven',
    feedback: 'event_givefeedback'
  }
}
